// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"133":"b01daa15","595":"f4200051","665":"b14ac78d"}[chunkId] + ".chunk.css";
};